// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XzYC58 {
  border: none;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  width: 500px;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  padding: var(--spacing-3);
  gap: var(--spacing-3);
  box-sizing: border-box;
  cursor: default;
  z-index: 1300;
}

.XzYC58::backdrop {
  background: var(--neutral-dark-opacity-50);
}

.XzYC58:focus {
  outline: none;
}

.XzYC58[open] {
  width: 500px;
}

.ZXQ6zy {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.N6LbAj {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cT0oN9 {
  height: 16px;
  width: 16px;
}

.zQyXAl {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-align: center;
}

.gH5KiC {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  text-align: center;
  width: 100%;
}

.ToGwXh {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  gap: var(--spacing-2);
}

.Uy2PDb {
  min-width: 100px;
}

.RQowy9 {
  color: var(--brand-tr-orange);
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/DuplicateTransaction/DuplicateTransaction.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,YAAY;EACZ,wCAAwC;EACxC,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB","sourcesContent":[".modal {\n  border: none;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  width: 500px;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-3);\n  gap: var(--spacing-3);\n  box-sizing: border-box;\n  cursor: default;\n  z-index: 1300;\n}\n\n.modal::backdrop {\n  background: var(--neutral-dark-opacity-50);\n}\n\n.modal:focus {\n  outline: none;\n}\n\n.modal[open] {\n  width: 500px;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.closeImage {\n  height: 16px;\n  width: 16px;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-align: center;\n}\n\n.caption {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  text-align: center;\n  width: 100%;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-2);\n}\n\n.button {\n  min-width: 100px;\n}\n\n.link {\n  color: var(--brand-tr-orange);\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `XzYC58`,
	"header": `ZXQ6zy`,
	"closeButton": `N6LbAj`,
	"closeImage": `cT0oN9`,
	"title": `zQyXAl`,
	"caption": `gH5KiC`,
	"actions": `ToGwXh`,
	"button": `Uy2PDb`,
	"link": `RQowy9`
};
module.exports = ___CSS_LOADER_EXPORT___;
